import { FunctionComponent } from 'react'
import Title from '@/components/_custom/Title/title'
import { useTranslation } from 'react-i18next'
import styles from './exportSettings.module.scss'
import ParentsExport from '@/components/Export/ParentsExport/ParentsExport'
import StaffsExport from '@/components/Export/StaffsExport/StaffsExport'
import DaycaresExport from '@/components/Export/DaycaresExport/DaycaresExport'
import TrusteesExport from '@/components/Export/TrusteesExport/TrusteesExport'
import ChildsExport from '@/components/Export/ChildsExport/ChildsExport.tsx'

const ExportSettings: FunctionComponent = () => {
    const { t } = useTranslation()

    return (
        <div className={styles.Container}>
            <div className={styles.TextContainer}>
                <Title text={t('myExport')} />
            </div>
            <div className={styles.CaseContainer}>
                <DaycaresExport daycares={[]} />
                <TrusteesExport />
                <StaffsExport daycares={[]} />
            </div>
            <div className={styles.CaseContainer}>
                <ParentsExport daycares={[]} isRpeOrLaep={false} />
                <ChildsExport daycares={[]} isRpeOrLaep={false} />
            </div>
        </div>
    )
}

export default ExportSettings
